export const FIELD_TYPE = {
  MANY2ONE: 'many2one',
  ONE2MANY: 'one2many',
  MANY2MANY: 'many2many',
  BOOLEAN: 'boolean',
}
